"use client";
import React, { useState } from "react";

const Accordion = ({ className, variant, title, children, titleClass = '', contentClass = '', defaultIsOpen = false }) => {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const toggleAccordion = () => {
    setIsOpen(prevState => !prevState);
  };

  // Handle key presses for accessibility
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent scrolling when pressing space
      toggleAccordion();
    }
  };

  return (
    <div className="filterAccordion">
      <div 
        className="accordionTitle"
        onClick={toggleAccordion} 
        onKeyUp={handleKeyPress} // Add key press handling
        role="button" // Make the div behave like a button
        tabIndex={0} // Make the div focusable
        aria-expanded={isOpen} // Add aria-expanded for accessibility
        aria-controls={`accordion-content-${variant}`} // Unique ID for content section
      >
        <div>{title}</div>
        <span className="accordionIcon">
          {isOpen ? 
            <span>
              <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" alt="toggle icon" loading="lazy">
                <path d="M1 2C0.716667 2 0.479167 1.90417 0.2875 1.7125C0.0958333 1.52083 0 1.28333 0 1C0 0.716667 0.0958333 0.479167 0.2875 0.2875C0.479167 0.0958333 0.716667 0 1 0H13C13.2833 0 13.5208 0.0958333 13.7125 0.2875C13.9042 0.479167 14 0.716667 14 1C14 1.28333 13.9042 1.52083 13.7125 1.7125C13.5208 1.90417 13.2833 2 13 2H1Z" fill="#E83134"></path>
              </svg>
            </span>
          : 
            <span>
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 8H1C0.716667 8 0.479167 7.90417 0.2875 7.7125C0.0958333 7.52083 0 7.28333 0 7C0 6.71667 0.0958333 6.47917 0.2875 6.2875C0.479167 6.09583 0.716667 6 1 6H6V1C6 0.716667 6.09583 0.479167 6.2875 0.2875C6.47917 0.0958333 6.71667 0 7 0C7.28333 0 7.52083 0.0958333 7.7125 0.2875C7.90417 0.479167 8 0.716667 8 1V6H13C13.2833 6 13.5208 6.09583 13.7125 6.2875C13.9042 6.47917 14 6.71667 14 7C14 7.28333 13.9042 7.52083 13.7125 7.7125C13.5208 7.90417 13.2833 8 13 8H8V13C8 13.2833 7.90417 13.5208 7.7125 13.7125C7.52083 13.9042 7.28333 14 7 14C6.71667 14 6.47917 13.9042 6.2875 13.7125C6.09583 13.5208 6 13.2833 6 13V8Z" fill="#E83134"></path>
              </svg>
            </span>
          }
        </span>
      </div>
      <div 
        id={`accordion-content-${variant}`} // ID for content section
        className={`filterTier ${contentClass} ${isOpen ? "openContent" : ""}`}
        role="region" // Add role region for better semantics
        aria-hidden={!isOpen} // Indicate if content is hidden
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
